import React,{useState, useEffect} from 'react'
import {motion} from 'framer-motion';
import { HiChevronLeft,HiChevronRight } from 'react-icons/hi';
import {ApplicationWrap,MotionWrap} from "../../wrapper";
import {urlFor, integrate} from '../../integrate'

import './Award.scss';

const Award = () => {
  const [awards, setAwards] = useState([ ]);
  const [index, setIndex] = useState(0);

  const handleClick = (index) => {
    setIndex(index)
  }

  useEffect(() => {
    const awardsQuery = `*[_type == "awards"]`;

    integrate.fetch(awardsQuery)
    .then((data)=> {
      setAwards(data);
    })

}, [])

const awd = awards[index];
  return (
    <>
     <h2 className='head-text'><span>Awards</span> & <span>Certificates</span></h2>
     {awards.length && (
       <>
       <div className="app__awards-item app_flex">
        {awd.imageurl && (
         <img src={urlFor(awd.imageurl)} alt="awards" />
       ) }
         <div className="app__awards-content">
             <h3 className="bold-text">{awd.name}</h3>
             <p className="p-text">{awd.description}</p>
         </div>
       </div>

       <div className="app__awards-btns app__flex">
         <div className="app__flex" onClick={()=> handleClick(index  === 0 ? awards.length -1 : index -1)}>
           <HiChevronLeft/>
         </div>
         <div className="app__flex" onClick={()=> handleClick(index  === awards.length -1 ? 0 : index +1)}>
           <HiChevronRight/>
         </div>
       </div>
       </>
     )}
    </>
    
  )
}

export default ApplicationWrap(MotionWrap(Award,'app__awards'), 'awards', 'app__primarybg');